<!-- 
  /** 
  * @author Mau de Pallares 
  * @company Erillam Healthcare 
  * @version 2.0 
  */ -->
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      hide-default-footer
      item-key="idStudy"
      show-select
      v-model="selected"
      value="idStudy"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon x-small @click="openModal(item)">
              <v-icon color="gray" v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </v-btn>
          </template>
          <span>Información de estudio</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.interpretationDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.interpretationDate) || '- - -'}}
      </template>
      <template v-slot:[`item.studyCloseDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.studyCloseDate) }}
      </template>
      <template v-slot:[`item.nameBirads`]="{ item }">
        <v-chip :color="$utilFront.getColorBirads(item.nameBirads)" x-small>
          {{ $utilFront.nonEmpty(item.idInterpretation) ? item.nameBirads : 'REPETIR' }}
        </v-chip>
      </template>
      <template v-slot:[`item.idInterpretation`]="{ item }">
          {{ item.idInterpretation || '- - -'}}
      </template>
      <template v-slot:[`item.fullNameInterpreter`]="{ item }">
          {{ item.fullNameInterpreter || '- - -'}}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";

export default {
  name: "PsychologyPendingTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    updateStatus: Function,
    itemsPerPage: Number,
    clearSelected: Boolean,
  },
  components: {
    MenuCrud,
    CancelationModal,
  },
  data() {
    return {
      idPatient: null,
      appointmentDialog: false,
      selected: [],
      dialogCancelation: false,
      headers: [
        {
          text: "Id interpretación",
          value: "idInterpretation",
          sortable: false,
          align: "center",
        },
        {
          text: "Id estudio",
          value: "idStudy",
          sortable: false,
          align: "center",
        },
        {
          text: "Nombre del paciente",
          value: "fullNamePatient",
          sortable: false,
          align: "center",
        },
        {
          text: "Modalidad",
          value: "fullNameModality",
          align: "center",
          sortable: false,
        },
        {
          text: "Perfil de estudio",
          value: "fullNameStudyProfile",
          align: "center",
          sortable: false,
        },
        {
          text: "BI-RADS",
          value: "nameBirads",
          align: "center",
          sortable: false,
        },
        {
          text: "Fecha de interpretación",
          value: "interpretationDate",
          align: "center",
          sortable: false,
        },
        {
          text: "Fecha de cierre del estudio",
          value: "studyCloseDate",
          align: "center",
          sortable: false,
        },
        {
          text: "Responsable",
          value: "fullNameInterpreter",
          align: "center",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      viewSendingDetails: false,
    };
  },
  watch: {
    selected: function() {
      if (this.selected.length > 1) {
        let data = this.selected.map((id) => {
          return { idStudy: id.idStudy };
        });
        this.$emit("beforeSending", data);
      } else if (this.selected.length == 1) {
        let data = [
          {
            idStudy: this.selected[0].idStudy,
          },
        ];
        this.$emit("beforeSending", data);
      } else if (this.selected.length == 0) {
        let data = [];
        this.$emit("beforeSending", data);
      }
    },
    clearSelected: function() {
      if (this.clearSelected) {
        this.selected = [];
      } else {
      }
    },
  },
  methods: {
    openModal(item) {
      this.viewSendingDetails = true;
      this.$emit("openModal", this.viewSendingDetails, {idStudy: item.idStudy});
    },
  },
};
</script>
